import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-24 px-4 bg-transparent relative overflow-hidden font-sans" data-id="element-197">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-[#10B981]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-198" />

      <div className="max-w-3xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center w-full" data-id="element-200">
          <ShieldCheckIcon className="w-20 h-20 text-[#10B981] mb-8 drop-shadow-[0_0_15px_rgba(16,185,129,0.4)]" data-id="element-201" />

          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-202">
            7 Días de Garantía Total
          </h2>

          <p className="text-lg md:text-xl text-textMuted max-w-2xl mb-12 font-medium leading-relaxed" data-id="element-203">
            Si no te convence, te devolvemos el 100% de tu dinero. Sin
            preguntas, sin vueltas.
          </p>

          <div className="w-full bg-cardBg/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-[#10B981]/20 mb-12 shadow-[0_0_30px_rgba(16,185,129,0.1)] text-left" data-id="element-204">
            <ul className="flex flex-col gap-4" data-id="element-205">
              {['Probá el MegaPack Universitario completo durante 7 días', 'Si no es lo que esperabas, pedí tu reembolso', 'Te devolvemos el 100% sin preguntas', 'El riesgo es cero. La oportunidad es enorme.'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-206">
                  <div className="w-6 h-6 rounded-full bg-[#10B981]/20 flex items-center justify-center shrink-0 mt-0.5 border border-[#10B981]/50" data-id="element-207">
                    <CheckIcon className="w-4 h-4 text-[#10B981]" strokeWidth={3} data-id="element-208" />
                  </div>
                  <span className="text-white/90 text-base md:text-lg font-medium" data-id="element-209">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <a href="#elegir-opcion" className="bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-black md:text-xl px-8 py-4 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(16,185,129,0.3)] hover:shadow-[0_0_30px_rgba(16,185,129,0.5)] hover:scale-105 inline-block text-center no-underline whitespace-nowrap w-full md:w-auto text-[14px]" data-id="element-210">
            QUIERO PROBARLO SIN RIESGO →
          </a>
        </motion.div>
      </div>
    </section>;
}